module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('figure', [_c('p', {
    staticClass: "image2"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_8",
      "title": "8"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Packinghouse workers, Buenos Amigos...",
      "height": "387",
      "src": "images/f0008-01.jpg",
      "width": "466"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Packinghouse workers, Buenos Amigos Plantation, El Progreso, Yoro, Honduras, September 2004")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b1d5196","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Image3.vue
// module id = 87
// module chunks = 0